<template>
  <h1>Page 404</h1>
</template>

<script>
export default {
  name: 'error-404'
}
</script>